export default __webpack_public_path__ + "static/media/closet4-1920w.e8ab3ee5.png";